export default __webpack_public_path__ + "static/media/oftmcss.30b423da.svg";